import React from 'react';
import styles from './WhySimpleeCreateExists.module.css';
import girl from './images/women.svg';
import { motion } from 'framer-motion';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
const WhySimpleeCreateExists: React.FC = () => {
    return (
        <div className={styles.container}>
            <div className={styles.textContent}>
                <OptimizedMotionH2 className={styles.title} type="slide-left" delay={0.2}>
                    Why <span className={styles.titleHighlight}>SimpleeCreate</span> matters{' '}
                    <span className={styles.wrenchIcon}>📢</span> today{' '}
                </OptimizedMotionH2>

                <OptimizedMotionP className={styles.description} type="slide-left" delay={0.4}>
                    <p>
                        Modern marketing teams face mounting pressure to create more content,
                        faster—without sacrificing brand consistency or quality. Yet, most workflows
                        are fragmented, approval processes lag, and brand voice gets diluted across
                        platforms. SimpleeCreate was built to solve that.
                    </p>

                    <p>
                        Born from a five-year journey leading content and broadcast tech innovation,
                        our team saw a recurring pain point: marketers and creators spend more time
                        managing workflows than crafting powerful messages. We built SimpleeCreate
                        to change that—turning content operations from a bottleneck into a
                        competitive advantage.
                    </p>
                </OptimizedMotionP>
            </div>
            <div className={styles.imageContainer}>
                <img
                    src={girl}
                    alt="Woman in yellow sweater holding laptop"
                    className={styles.heroImage}
                />
            </div>
        </div>
    );
};

export default WhySimpleeCreateExists;
